import React, { PropsWithChildren, ReactNode, useCallback } from "react";
import { Platform } from "react-native";

import * as Haptics from "expo-haptics";
import { ListItem, ListItemProps } from "arkh";

export function SelectListItem(
  props: PropsWithChildren<
    {
      notSelectable?: boolean;
      selected: boolean;
      onPress(): void;
      isFirst?: boolean;
      isLast?: boolean;
      left?: ReactNode;
    } & Pick<ListItemProps, "border">
  >
) {
  const onPress = useCallback(() => {
    if (Platform.OS === "ios") {
      Haptics.selectionAsync();
    }
    props.onPress();
  }, [props]);

  return (
    <ListItem
      onPress={onPress}
      isFirst={props.isFirst}
      isLast={props.isLast}
      disabled={props.notSelectable}
      left={props.left}
      border={props.border}
      right={
        props.notSelectable ? null : (
          <ListItem.SelectIndicator selected={props.selected} />
        )
      }
    >
      {props.children}
    </ListItem>
  );
}
